export default "__VITE_ASSET__4ehpd_5y__"